export default {
    namespaced: true,
    state: {
        access_campaign_personal_ids: {},
        access_industry_personal_ids: {},
        access_page_group_personal_ids: {},
        score_condition_personal_ids: {},
        person_visit_notification_personal_ids: {},
        person_condition_personal_ids: {},
        access_page_personal_ids: {}
    },
    mutations: {
        // access_campaign用の個人IDをセット
        setAccessCampaignPersonalIds(state, access_campaign_personal_ids) {
            state.access_campaign_personal_ids = access_campaign_personal_ids;
        },
        // access_industry用の個人IDをセット
        setAccessIndustryPersonalIds(state, access_industry_personal_ids) {
            state.access_industry_personal_ids = access_industry_personal_ids;
        },
        // access_page_group用の個人IDをセット
        setAccessPageGroupPersonalIds(state, access_page_group_personal_ids) {
            state.access_page_group_personal_ids = access_page_group_personal_ids;
        },
        // score_condition用の個人IDをセット
        setScoreConditionPersonalIds(state, score_condition_personal_ids) {
            state.score_condition_personal_ids = score_condition_personal_ids;
        },
        // person_visit_notification用の個人IDをセット
        setPersonVisitNotificationPersonalIds(state, person_visit_notification_personal_ids) {
            state.person_visit_notification_personal_ids = person_visit_notification_personal_ids;
        },
        // person_condition用の個人IDをセット
        setPersonConditionPersonalIds(state, person_condition_personal_ids) {
            state.person_condition_personal_ids = person_condition_personal_ids;
        },
        // access_page用の個人IDをセット
        setAccessPagePersonalIds(state, access_page_personal_ids) {
            state.access_page_personal_ids = access_page_personal_ids;
        }
    },
    actions: {},
    getters: {
        // access_campaign用の個人IDを取得
        getAccessCampaignPersonalIds(state) {
            return state.access_campaign_personal_ids;
        },
        // access_industry用の個人IDを取得
        getAccessIndustryPersonalIds(state) {
            return state.access_industry_personal_ids;
        },
        // access_page_group用の個人IDを取得
        getAccessPageGroupPersonalIds(state) {
            return state.access_page_group_personal_ids;
        },
        // score_condition用の個人IDを取得
        getScoreConditionPersonalIds(state) {
            return state.score_condition_personal_ids;
        },
        // person_visit_notification用の個人IDを取得
        getPersonVisitNotificationPersonalIds(state) {
            return state.person_visit_notification_personal_ids;
        },
        // person_condition用の個人IDを取得
        getPersonConditionPersonalIds(state) {
            return state.person_condition_personal_ids;
        },
        // access_page用の個人IDを取得
        getAccessPagePersonalIds(state) {
            return state.access_page_personal_ids;
        }
    }
};
